import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _pick from "lodash/pick";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { MigrationResult } from './migration-result';
const getOptionalValue = value => value == null ? undefined : value;
export const migrateV0ToV1 = data => {
  const baseData = _pick(data, ['title', 'xp', 'course_id', 'chapter_id']);
  return new MigrationResult('v1', _objectSpread(_objectSpread({}, baseData), {}, {
    assignment: getOptionalValue(data.assignment),
    video: {
      projector_key: getOptionalValue(data.projector_key),
      video_hls: getOptionalValue(data.video_hls),
      video_link: getOptionalValue(data.video_link)
    }
  }));
};
export const migrations = {
  v0: migrateV0ToV1
};
export default migrations;